import { createFileRoute, Outlet } from '@tanstack/react-router';
import { commonSearchSchema } from '@/routes/-shared/commonSearchSchema';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import { useTenantFeatureFlags } from '@/lib/hooks/use-tenant-feature-flags';
import { MachineChecks } from '@/pages/machine-checks';
import z from '@/lib/zod';
import {
  optionalSearchBoolean,
  optionalSearchString,
} from '@/lib/zod-search-params';

export const machineChecksSearchSchema = commonSearchSchema.extend({
  /** Sezione: scadenzario (default), verifiche, anomalie. */
  view: optionalSearchString(),
  tab: z.string().nullish(),
  /** Pannello Filtri dello scadenzario (nomi dell'API). */
  companyId: optionalSearchString(),
  machineId: optionalSearchString(),
  responsibleUserId: optionalSearchString(),
  hasOpenFindings: optionalSearchBoolean(),
  dueFrom: optionalSearchString(),
  dueTo: optionalSearchString(),
  /** Pannello Filtri delle verifiche: esiti CSV. */
  outcomes: optionalSearchString(),
});

export const Route = createFileRoute(
  '/protected/_layout/machine-checks/_layout'
)({
  validateSearch: machineChecksSearchSchema,
  component: MachineChecksLayout,
});

/** Sezione visibile con il permesso Macchine E il feature flag del tenant. */
function MachineChecksLayout() {
  const { canAccessMachines, canReadMachineChecks, isLoading } =
    usePermissions();
  const { isMachinesEnabled, isLoading: isLoadingFlags } =
    useTenantFeatureFlags();
  return (
    <RoleGuard
      hasAccess={canAccessMachines && canReadMachineChecks && isMachinesEnabled}
      isLoading={isLoading || isLoadingFlags}
    >
      <MachineChecks />
      <Outlet />
    </RoleGuard>
  );
}
